

// export function formatPhone(phone) {
//   if (!phone) return "";

//   // ✅ convert to string
//   phone = phone.toString();

//   const khmerToEnglish = {
//     "០": "0", "១": "1", "២": "2", "៣": "3", "៤": "4",
//     "៥": "5", "៦": "6", "៧": "7", "៨": "8", "៩": "9"
//   };

//   let clean = phone.replace(/[០-៩]/g, d => khmerToEnglish[d]);

//   clean = clean.replace(/\D/g, "");

//   if (clean.length === 9) {
//     return clean.replace(/(\d{3})(\d{3})(\d{3})/, "$1 $2 $3");
//   }

//   if (clean.length === 10) {
//     return clean.replace(/(\d{3})(\d{3})(\d{4})/, "$1 $2 $3");
//   }

//   return phone;
// }

export function formatPhone(phone) {
  if (!phone) return "";

  phone = phone.toString();

  const khmerToEnglish = {
    "០": "0", "១": "1", "២": "2", "៣": "3", "៤": "4",
    "៥": "5", "៦": "6", "៧": "7", "៨": "8", "៩": "9"
  };

  // 👇 old browser safe
  let clean = phone.replace(/[០-៩]/g, function(d) {
    return khmerToEnglish[d];
  });

  clean = clean.replace(/\D/g, "");

  if (clean.length === 9) {
    return clean.replace(/(\d{3})(\d{3})(\d{3})/, "$1 $2 $3");
  }

  if (clean.length === 10) {
    return clean.replace(/(\d{3})(\d{3})(\d{4})/, "$1 $2 $3");
  }

  return phone;
}